export default __webpack_public_path__ + "static/media/3035.17768607.jpg";